import createModel from 'utils/model'
import dayjs from 'dayjs'
import constants from 'crm/common/constants'
import {statByDate, exportStatByDate} from 'crm/services/stat-contact-customer'

const {dateFormat} = constants

function getInitParams() {
    return {
        department_id: undefined,
        user_id: undefined,
        // 不包含今天
        date_from: dayjs().subtract(7, 'days').format(dateFormat),
        date_to: dayjs().subtract(1, 'days').format(dateFormat),
    }
}

export default createModel({
    namespace: 'crm_statContactCustomer',

    state: {
        params: getInitParams(),
        data: [],
        summary: {},
        chartData: {},
        statType: 'date',
    },

    effects: {
        *statByDate({payload}, {call, put, select}) {
            const params = yield select(
                ({crm_statContactCustomer}) => crm_statContactCustomer.params,
            )
            const query = {...params, ...payload.params}

            const res = yield call(statByDate, query)
            if (res && res.data) {
                const {data} = res

                const chatCountData = []
                const messageCountData = []
                const replyPercentageData = []
                const avgReplyTimeData = []

                let chatCountTotal = 0
                let messageCountTotal = 0

                data.forEach((item) => {
                    const date = dayjs(item.stat_time * 1000).format('MM-DD')
                    const {chat_cnt, message_cnt, reply_percentage, avg_reply_time} = item

                    chatCountTotal += chat_cnt || 0
                    messageCountTotal += message_cnt || 0

                    chatCountData.push({
                        date,
                        value: chat_cnt,
                    })
                    messageCountData.push({
                        date,
                        value: item.message_cnt,
                    })
                    replyPercentageData.push({
                        date,
                        value: reply_percentage || 0,
                    })
                    avgReplyTimeData.push({
                        date,
                        value: avg_reply_time || 0,
                    })
                })

                yield put({
                    type: 'setProperty',
                    payload: {
                        data: data.reverse(),
                        params: query,
                        summary: {
                            chat_cnt: chatCountTotal,
                            message_cnt: messageCountTotal,
                        },
                        chartData: {
                            chat_cnt: chatCountData,
                            message_cnt: messageCountData,
                            reply_percentage: replyPercentageData,
                            avg_reply_time: avgReplyTimeData,
                        },
                    },
                })
            }
        },
        *exportStatByDate(_, {call, select}) {
            const params = yield select(
                ({crm_statContactCustomer}) => crm_statContactCustomer.params,
            )
            return yield call(exportStatByDate, params)
        },
    },

    reducers: {
        setProperty(state, action) {
            return {...state, ...action.payload}
        },
    },
})
